import { action, makeAutoObservable } from 'mobx';
import {
  fetchActiveJobPostings,
  inviteCandidateToBulkJobPostings
} from '../api/SlmService';
import notificationStore from './NotificationStore';
import bulkJobInvitationNotificationStore from './BulkJobInvitationNotificationStore';

class BulkJobInvitationStore {
  // if active job postings are available and owned by pro
  bulkJobInvitationAvailable = false;

  // Determines if the bulk Job Invitation modal is open or not
  bulkJobInvitationOpen = false;

  candidate = {};

  // to store job posting Objects
  jobPostings = [];

  selectedJobIds = [];

  paginationInfo = {};

  isJobPostingsLoading = false;

  page = 1;

  notificationStore = {};

  sort = {
    by: null,
    order: null
  };

  constructor(newNotificationStore, newBulkJobInvitationNotificationStore) {
    this.notificationStore = newNotificationStore;
    this.bulkJobInvitationNotificationStore = newBulkJobInvitationNotificationStore;
    makeAutoObservable(this);
  }

  setSort = (next) => {
    this.sort = { ...next };
  };

  setCandidate = (candidate) => {
    this.candidate = candidate;
  };

  setJobPostings = (jobPostings) => {
    this.jobPostings = jobPostings;
  };

  setSelectedJobIds = (selectedJobIds) => {
    this.selectedJobIds = selectedJobIds;
  };

  addSelectedJob = (jobId) => {
    this.setSelectedJobIds([...this.selectedJobIds, jobId]);
  };

  removeSelectedJob = (jobId) => {
    this.setSelectedJobIds(this.selectedJobIds.filter(function (id) {
      return id !== jobId;
    }));
  };

  setPaginationInfo = (paginationInfo) => {
    this.paginationInfo = paginationInfo;
  };

  setIsJobPostingsLoading = (isJobPostingsLoading) => {
    this.isJobPostingsLoading = isJobPostingsLoading;
  };

  setPage = (page) => {
    this.page = page;
  };

  /**
   * Control Job Posting Dialog open state
   * @param {Boolean} value
   */
   toggleBulkJobInvitationOpen = (value = false) => {
     this.bulkJobInvitationOpen = value;
   };

   toggleBulkJobInvitationAvailable = (value = false) => {
     this.bulkJobInvitationAvailable = value;
   };

  flushJobPostings = () => {
    this.jobPostings = [];
  };

  fetchActiveJobPostings = (candidateId, withLoader = true) => {
    if (withLoader) {
      this.setIsJobPostingsLoading(true);
    }
    fetchActiveJobPostings(candidateId, this.page, this.sort).then(
      action('success', (res) => {
        this.setPaginationInfo(res?.metadata?.paginationInfo);
        this.setJobPostings(res?.jobPostings);
        if (res.jobPostings.length > 0) {
          this.bulkJobInvitationAvailable = true;
        }
      }),
      action('error', () => {
        this.notificationStore.setError('Failed to retrieve job postings.');
      })
    ).finally(() => {
      this.setIsJobPostingsLoading(false);
    });
  };

  inviteCandidateToBulkJobPostings = (candidateId) => {
    inviteCandidateToBulkJobPostings(this.selectedJobIds, candidateId).then(
      action('success', () => {
        this.bulkJobInvitationNotificationStore.showBulkJobInvitationSentNotification();
        this.fetchActiveJobPostings(candidateId);
      }),
      action('error', () => {
        notificationStore.setError('Failed to invite candidate to job(s).');
      })
    ).finally(() => {
      this.setSelectedJobIds([]);
    });
  };
}

export default new BulkJobInvitationStore(notificationStore, bulkJobInvitationNotificationStore);
